export default "__VITE_ASSET__lvyuDlex__"